<template>
  <div>
    <main>
      <div id="HomeContainer" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/images/finishes-bg.jpg') + ')' }">
          <div class="ContentAligher">

            <div class="row">
              <div class="col-md-5 col-md-offset-7">
                  <div id="HeroTitle">
                    <h1 class="bold">Finishes</h1>
                    <p>At USC we pride ourselves in our high-quality workmanship. When creating your custom order, we team up with top quality companies to provide you with the best product possible. Find a list of some of those companies below and feel free to check out their websites, as well.</p>
                    <a class="link" v-on:click="scrollMeTo('LogoList');">Our trusted clients</a>
                  </div>
              </div>
            </div>

          </div>
      </div>
    </main>
    <section class="ContentAligher SectionSpacing" ref="LogoList">

      <div class="row">
          <div class="col-md-10 col-md-offset-1">

              <div class="row">

                <div class="col-md-12 col-sm-offset-0">
                    <template v-for="(fi, key, index) in finishes_list">
                      <h2 class="bold yellow">{{ fi.title }}</h2>
                      <ul class="row fi_logos">
                        <li v-for="(fii, key, index) in fi.images" class="col-md-3 col-sm-4 col-xs-6">
                              <a :href="fii.link" target="_blank"><img :src="base_path + fii.logo_img"  /></a>
                          </li>
                      </ul>
                      <br/><br/><br/>
                      </template>
                  </div>


                <div class="col-md-12" v-if="finishes_list.length === 0">
                  <p>Sorry, No results found.</p>
                </div>
              </div>

        </div>
      </div>


    </section>
    
    <section id="OurClientsWrap" class="double">
    <div class="bg_yellow SectionSpacing">
        <div class="ContentAligher SectionTopSpacing SectionBottomSpacing">
            <div class="row">
              <div class="col-xs-10 col-xs-offset-1 ">
                  <div class="row">
                    <div class="col-md-12">
                      <ul id="testimonialsSlider">
                        <li v-for="testi in testimonials">
                          <div>
                            <p>{{ testi.testimonial }}</p><strong>{{ testi.name }}</strong><br/><span>{{ testi.position_title }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <div class="BGArrowLeft parallax"  data-speed="20" data-margin="200" data-rotate="0" data-rotatestatus="false" ></div>
  </section>




    <rwv-general-form></rwv-general-form>
  </div>
</template>
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';


import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);


import '@/assets/js/lightslider'

import RwvGeneralForm from '@/components/GeneralForm';
import RwvOurClients from '@/components/OurClients';


export default{
  name: 'OurClients',
  components: {
    RwvGeneralForm, 
    RwvOurClients
  },
  data: function() {
    return {
     base_path: BASE_URL,
     finishes_list: [],
     testimonials:[]
    }
  },
  mounted() {
      $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });

      axios.get(API_BASE_URL + 'finishes/list')
      .then(response => {this.finishes_list = response.data});

      axios.get(API_BASE_URL + 'testimonials/list/')
      .then(response => {this.testimonials = response.data});


        $('#testimonialsSlider').lightSlider({
            item:2,
            slideMove:1,
            enableTouch:true,
            enableDrag:false,
            loop:false,
            slideMargin:0,
            responsive : [
                {
                    breakpoint:678,
                    settings: {
                        item:1,
                        slideMove:1,
                      }
                }
            ]
          }); 
      
      
  },
  updated(){
     //$(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
      }, 100);
  },
  methods: {
    scrollMeTo(refName) {
        
        var element = this.$refs[refName];
        var top = element.offsetTop;

        window.scrollTo(0, top);
    }
  },
  computed: {
  }
  
}

</script>
<style>
@import './../assets/css/lightslider.css';
</style>


// WEBPACK FOOTER //
// src/views/Finishes.vue